import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const fieldsStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
`;

export const fullWidthFieldStyles = css`
  max-width: unset;
`;

export const noticeWrapperStyles = css`
  margin: 0 auto;

  &:empty {
    display: none;
  }
`;

export const notificationStyles = css`
  width: 100%;
`;

export const noticeContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`;

export const actionsStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`;
